import { SearchContext, SearchMode } from '../../../model/search/ISearch';
import { BasicSearch as BasicSearchModel } from '../../../model/search/basic/BasicSearch';

import { Factory } from '../../../services/Factory';

import IAugmentedJQuery = angular.IAugmentedJQuery;
import IAttributes = angular.IAttributes;
import IScope = angular.IScope;

export interface ISearchScope extends IScope {
  loggedIn: boolean;
  project;
  collection: any;
  basicSearch: BasicSearchModel;
  searchContext: SearchContext;
  setSearchContext: (context: SearchContext) => void;
  searchMode: SearchMode;
  searchInProgress: boolean;
  hasSearchError: boolean;
  submitQuery: Function;
  toggleSearch: Function;
  SearchContext: typeof SearchContext;
  SearchMode: typeof SearchMode;
  executeVoiceSearch: Function,
  listening: boolean
}

export interface ISearchAttributes extends IAttributes {
}

export class BasicSearch implements angular.IDirective {
  public restrict = 'E';
  public templateUrl: string;
  public scope = {};
  public link: (scope: ISearchScope, element: IAugmentedJQuery, attrs: ISearchAttributes) => void;

  constructor(rootScope, $timeout, stateService: app.services.state.StateService, projectService: app.services.project.ProjectService, collectionService: app.services.collections.CollectionService, searchService: app.services.search.basic.SearchService, layerService, webSpeechService: app.services.speech.WebSpeechService) {
    this.templateUrl = 'partials/search/basic/search.html';

    this.link = (scope: ISearchScope, element: IAugmentedJQuery, attrs: ISearchAttributes) => {
      if (Utilities.isIE()) {
        element.find("[type='text']").css("height", "34px");
      }

      scope.window = window;
      scope.basicSearch = new BasicSearchModel(SearchContext.Project, "");
      scope.searchMode = SearchMode.Basic;
      scope.SearchContext = SearchContext;
      scope.searchContext = SearchContext.Project;
      scope.SearchMode = SearchMode;
      scope.loggedIn = stateService.IsLoggedIn();
      scope.project = projectService.GetCurrentProject();
      scope.collection = collectionService.GetCurrentCollection();
      scope.hasSearchError = false;

      scope.$on(EVENTS.LOGIN_REQUIRED, () => scope.loggedIn = false);
      scope.$on(EVENTS.LOGIN_CONFIRMED, () => scope.loggedIn = true);
      scope.$on(layerService.EVENTS.HIDE_SEARCH, () => scope.basicSearch = new BasicSearchModel(scope.searchContext, ""));
      scope.$on("ProjectService.CurrentProjectChanged", (event, project) => {
        scope.project = project;
      });

      scope.$on("CollectionService.CurrentCollectionChanged", (event, collection) => {
        scope.collection = collection;
        scope.searchContext = collection ? SearchContext.Collection : SearchContext.Project;
      });

      scope.$on("SearchModeChanged", (e, mode) => {
        scope.searchMode = mode;
        scope.basicSearch = new BasicSearchModel(scope.searchContext, "");
      });

      scope.$on("Search.SearchExecuted", results => scope.searchMode = SearchMode.Basic);

      scope.$on("Search.VoiceCommandDetected", results => {
        scope.listening = false;
        scope.$apply();
      });

      scope.$on("BasicSearch.Triggered", (e, expression) => {
        scope.basicSearch.expression = expression;
        scope.$apply();
      });

      scope.$watch("basicSearch.expression", (newQuery: string, oldQuery: string) => {
        scope.basicSearch.expression = newQuery.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');

        if (newQuery && !oldQuery) {
          layerService.pushLayer(layerService.LAYERS.SEARCH);
        } else if (!newQuery && oldQuery) {
          layerService.popLayer();
        }

        if (newQuery) {
          scope.searchInProgress = true;
          rootScope.$broadcast("Search.SearchExecuted", {advanced: false, expression: newQuery});
        }
      });

      scope.$on("Search.SearchSuccess", () => scope.hasSearchError = false);
      scope.$on("Search.SearchError", () => scope.hasSearchError = true);

      scope.$watch("searchContext", context => rootScope.$broadcast("SearchContext.Changed", context));

      // User picked a scope from the dropdown: re-run the current search (basic or advanced)
      // under the new context, but only while they're actually viewing results.
      scope.setSearchContext = (context: SearchContext) => {
        if (context === scope.searchContext) return;

        scope.searchContext = context;
        rootScope.$broadcast("SearchContext.Changed", context);

        if (layerService.getTopLayer() === layerService.LAYERS.SEARCH) {
          rootScope.$broadcast("Search.ContextChangedByUser", context);
        }
      };

      scope.$on("SearchContext.Changed.Externally", (e, context: SearchContext) => {
        scope.searchContext = context;
        rootScope.$broadcast("SearchContext.Changed", context);
      });

      scope.submitQuery = () => layerService.pushLayer(layerService.LAYERS.SEARCH);

      scope.toggleSearch = () => {
        scope.searchMode = scope.searchMode == SearchMode.Advanced ? SearchMode.Basic : SearchMode.Advanced;
        rootScope.$broadcast("SearchModeChanged", scope.searchMode);
      }

      scope.executeVoiceSearch = () => {
        if (scope.listening) {
          webSpeechService.stop();
          scope.listening = false;
        } else {
          webSpeechService.start();
          scope.listening = true;
        }
      }
    }
  }
}

frontendApp.directive("iioBasicSearch", ["$rootScope", "$timeout", "StateService", "ProjectService", "CollectionService", "BasicSearchService", "LayerService", "WebSpeechService", Factory.Create(BasicSearch)]);
